export default "__VITE_ASSET__DfWBqtEV__"